<div class="content-heading">
  <div class="header-container">
    <h3>Monedas</h3>
    <small>Catálogo de monedas para operaciones fiscales</small>
  </div>
</div>

<div class="container-fluid">
  <div class="card card-default">
    <div class="card-body">

      <div class="row">
        <div class="ml-auto mr-3 align-self-end">
          <aph-custom-buttons type="button" preset="refresh" (btnClick)="refresh()"></aph-custom-buttons>
        </div>
        <div class="col-12">
          <app-ceq-table #CeqGrid [gridAdditionalOptions]="gridOptions" [columnDef]="columnDefs"
            (apiEmitter)="gridEmiter($event)">
          </app-ceq-table>
        </div>
      </div>

      <div class="row mt-4 align-items-center">
        <div class="col-md-12">
          <div class="pagesize-control d-flex align-items-center">
            <span class="mr-2">Registros por página:</span>
            <select class="form-control w-auto" (change)="onPageSizeChange($event.target.value)">
              <option *ngFor="let size of PageSizes" [value]="size">{{size}}</option>
            </select>
          </div>
        </div>

        <div class="col-md-12 mt-2">
          <aph-custom-buttons preset="add" label="Nueva moneda" (btnClick)="btnAddClick()">
          </aph-custom-buttons>
        </div>
      </div>

    </div>
  </div>
</div>